import { APP_BASE_URL } from "../appconfig/Settings";
import axiosInstance from "../config/axiosInstance";

//common api call start

// get All Simple Details
export const getAllDetails = async (slug: any) => {
  try {
    const response = await axiosInstance(APP_BASE_URL + slug);
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

//getSpecificItemDeyails
export const getSpecificItemDetails = async (slug: any, firstParameterName: any, firstValue: any) => {
  try {
    const response = await axiosInstance(APP_BASE_URL + slug + `${"?" + firstParameterName}=` + firstValue);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//getSpecificItemDeyails
export const getTwoFilteredDetails = async (slug: any, firstParameterName: any, firstValue: any, secParameterName: any, secValue: any) => {
  try {
    const response = await axiosInstance(APP_BASE_URL + slug + `${"?" + firstParameterName}=` + firstValue + `${"&" + secParameterName}=` + secValue);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//getSpecific Details from id
export const getSpecificDetails = async (slug: any, id: any) => {
  try {
    const response = await axiosInstance(APP_BASE_URL + slug + "/" + id);
    return response?.data.data;
  } catch (error) {
    throw error;
  }
};

//common post api
export const postAllData = async (slug: any, requestData: any) => {
  try {
    const response = await axiosInstance.post(APP_BASE_URL + slug, requestData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//common post api
export const postDataByID = async (slug: any, id: any) => {
  try {
    const response = await axiosInstance.post(APP_BASE_URL + slug + "/" + id);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//updateData
export const updateData = async (slug: any, id: any, requestData: any) => {
  try {
    const response = await axiosInstance.post(APP_BASE_URL + slug + "/" + id, requestData);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//delete data
export const deleteData = async (slug: any, id: any, data?: any) => {
  try {
    const response = await axiosInstance.delete(APP_BASE_URL + slug + "/" + id, data ? { data } : undefined);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//common api call end
